const state = {
    sm_contracts_purchase_sales: [],
    sm_contracts_purchase_sale_types: [],
}

export default state;
